// extracted by mini-css-extract-plugin
export default {"multiselect":"multiselect__CqKAb","multiselect__title":"multiselect__title__HzgtZ"};